<script>
    import {createEventDispatcher, onMount} from "svelte";

    const dispatch = createEventDispatcher();

    function emitNext() {
        dispatch('next');
    }

    function emitPrevious() {
        dispatch('previous');
    }

    function handleScroll(e) {
        if (e.deltaY > 0) {
            return emitNext();
        }
        return emitPrevious();
    }

    function throttle(func, timeFrame) {
        let lastTime = 0;
        return function (event) {
            let now = new Date();
            if (now - lastTime >= timeFrame) {
                func(event);
                lastTime = now;
            }
        };
    }

    function shouldCall(prev, curr) {

        if (Math.abs(curr) < 15) { // Only scroll when over a given value
            return false
        }

        if (prev === curr) { // Values match, return false
            return false;
        }
        if (prev === 1 && curr < -1 ) { // Initial scroll up, return true
            return true;
        }
        if (prev === 1 && curr > 1) { // Initial scroll down, return true
            return true;
        }
        if (prev > 1 && curr < 1) { // Changed scroll direction to up, return true
            return true;
        }
        return prev < 1 && curr > 1; // Return changed scroll direction to down
    }

    let timeOut;

    function debounce(method, delay) {
        let deltaY = 1;

        return (event) => {
            if (shouldCall(deltaY, event.deltaY)) {
                method(event);
                deltaY = event.deltaY;
            }
            clearTimeout(timeOut);
            timeOut = setTimeout(function(){
                deltaY = 1;
            }, delay);
        }
    }


    const throttleScrollHandler = debounce(handleScroll, 25);

    function addScrollListeners() {
        document.querySelector('html')
            .addEventListener('mousewheel', throttleScrollHandler);
        document.querySelector('html')
            .addEventListener('DOMMouseScroll', throttleScrollHandler);
    }

    function addSwipeListeners() {
        document.addEventListener('swiped-up', emitNext);
        document.addEventListener('swiped-down', emitPrevious);
    }


    onMount(() => {
        addScrollListeners();
        addSwipeListeners();
    });
</script>